import { render } from "./ModalGuideSize.vue?vue&type=template&id=699e0a15&scoped=true"
const script = {}

import "./ModalGuideSize.vue?vue&type=style&index=0&id=699e0a15&lang=scss&scoped=true"

import exportComponent from "/Users/davidebertuzzi/WebstormProjects/procremonafrontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-699e0a15"]])

export default __exports__